import React from 'react';
import SVG from 'react-inlinesvg';
import { ControlButton } from '../../../control-button/control-button';
import { ObjectOrderProps } from '../font-drawer-types';
import styles from '../font-drawer.module.scss';
import { SendToBackSVG, BringToFrontSVG } from '../utils/svg';

export const ObjectOrder = ({
  onBringToFront,
  onSendToBack,
  bringToFrontLabel,
  sendToBackLabel,
}: ObjectOrderProps): React.ReactElement => {
  return (
    <div className={styles['object-order']}>
      <ControlButton
        buttonClass={styles['object-order-button']}
        textClass={styles['object-order-button-text']}
        testId="bring-to-front"
        label={bringToFrontLabel}
        onClick={onBringToFront}
      >
        <SVG
          src={BringToFrontSVG}
          title={bringToFrontLabel}
          description={bringToFrontLabel}
          className={styles['object-order-button-svg']}
        />
      </ControlButton>
      <ControlButton
        buttonClass={styles['object-order-button']}
        textClass={styles['object-order-button-text']}
        testId="send-to-back"
        label={sendToBackLabel}
        onClick={onSendToBack}
      >
        <SVG
          src={SendToBackSVG}
          title={sendToBackLabel}
          description={sendToBackLabel}
          className={styles['object-order-button-svg']}
        />
      </ControlButton>
    </div>
  );
};
